export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";
export const SET_PATIENT_RESULT= "SET_PATIENT_RESULT";
export const SET_DOCTORS_INGROUP= "SET_DOCTORS_INGROUP";
export const SET_SEARCH_BUTTON_CLICK = "SET_SEARCH_BUTTON_CLICK"